module.exports = __webpack_public_path__ + "img/undraw_add_color_re_buro.94ff0cc6.svg";